var classes = {"overlayMenuImage":"oRy72","overlayMenuImageCTA":"wCyIu","overlayMenuImageWidth":"R1rEa"};

export { classes as default };
